/* src/app/references/references.component.scss */
.white-bg {
  background: white;
  padding: 20px;
}
.white-bg .page {
  border-bottom: 5px solid #0022ab;
  padding: 20px 20px;
  text-align: left;
}
/*# sourceMappingURL=references.component.css.map */
